module.exports = __webpack_public_path__ + "img/Malwares_Attackers.bbe4af7.svg";